module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-maedori2-55621b56c6844740357e84da4a99f998.jpg";